import script from "./ServiceNameUnit.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceNameUnit.vue?vue&type=script&setup=true&lang=js"

import "./ServiceNameUnit.vue?vue&type=style&index=0&id=bb7fe59c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7fe59c"]])

export default __exports__